module.exports = __webpack_public_path__ + "templates.payment_slip_modal-a86f272b.html";